module.exports = __webpack_public_path__ + "img/green-checkmark-badge.f09978e3.svg";